import { Item } from "./Item";
import { Root } from "./Root";

/** Cross-fades icons in place: every item shares one spot, and the one matching the root's `value` shows. */
export const IconSwap = {
  Root,
  Item,
};

export type { IconSwapItemProps } from "./Item";
export type { IconSwapRootProps } from "./Root";
